import { useContext } from 'react';

import type { AuthorizationData } from '../types';

import { createGaEvent, dispatchGaEvent } from 'app/packages/analytics';

import { AuthContext } from '../context';

export function useTelegramOptions() {
  const {
    authData: { telegramProcessing },
    setAuthData,
  } = useContext(AuthContext);

  const handleTelegramOnSuccess = () => {
    if (typeof window === 'undefined') {
      return;
    }

    dispatchGaEvent(createGaEvent({ event: 'logInTelegramSucess' }));

    window.location.reload();
  };
  const handleTelegramOnFail = () => {
    setAuthData((prevState: AuthorizationData) => ({
      ...prevState,
      telegramProcessing: false,
      telegramError: true,
    }));
  };
  const handleTelegramOnProcessing = () => {
    setAuthData((prevState: AuthorizationData) => ({
      ...prevState,
      telegramProcessing: true,
    }));
  };

  return {
    telegramProcessing,
    handleTelegramOnSuccess,
    handleTelegramOnFail,
    handleTelegramOnProcessing,
  };
}
